var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyDnadnaIcon = function SvgWhyDnadnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0743 35.2499C9.43814 33.3954 5.99159 32.4926 3.39825 32.25M24.8947 37.7477C28.8251 37.7102 31.5509 36.2178 33.8363 33.9324C37.7887 29.98 39.3696 24.7101 35.1538 14.1704C33.2345 9.37227 32.3346 5.84831 32.1309 3.22565",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 12.5997C22.6151 12.5997 19.4 14.6001 18 15.6001L33.6 31.7997C35.8638 29.1586 36.7383 25.5991 35.9561 22.2097L35.4 19.7998L34.2 14.9997C30 13.1995 28.2 12.5997 25.2 12.5997Z",
    fill: "#FEECAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1549 14.1697C40.6957 16.386 44.5374 17.243 47.2542 17.2383M17.1441 47.3483C17.1487 44.6316 16.2917 40.7899 14.0754 35.2491C9.85953 24.7094 11.4405 19.4395 15.3929 15.4871C17.7855 13.0945 20.661 11.5709 24.896 11.6763",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4045 15.5001L33.8331 33.9287",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhyDnadnaIcon;